/**
 * Lost & Found common request recommendations for the add/edit form sidebar.
 * Split into Lost and Found sections. Short label = sidebar pill; full text = populates title/description when clicked.
 */

import type { RequestRecommendationSection } from "../community/requestRecommendationTypes";

/** Recommendations for items you lost. */
export const LOST_RECOMMENDATIONS: RequestRecommendationSection = {
  title: "Lost",
  items: [
    { label: "Lost package", text: "Lost a package that was delivered today" },
    {
      label: "Lost wallet",
      text: "Lost wallet or personal item in common areas",
    },
    {
      label: "Wrong unit delivery",
      text: "Package delivered to the wrong unit",
    },
  ],
};

/** Recommendations for items you found. */
export const FOUND_RECOMMENDATIONS: RequestRecommendationSection = {
  title: "Found",
  items: [
    { label: "Keys in lobby", text: "Found a set of keys in the lobby" },
    { label: "Phone in elevator", text: "Found a phone in the elevator" },
    {
      label: "Clothing in shared spaces",
      text: "Found clothing or personal belongings in shared spaces",
    },
  ],
};

/** Both sections in display order for the Lost & Found page sidebar. */
export const LOST_FOUND_SIDEBAR_SECTIONS: RequestRecommendationSection[] = [
  LOST_RECOMMENDATIONS,
  FOUND_RECOMMENDATIONS,
];
